import React, { useCallback, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { savePortalSession } from "@/lib/portalAuth";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  const exchange = useCallback(async (sid, portalType) => {
    try {
      const { data } = await http.post("/portal/auth/session", { session_id: sid, portal_type: portalType });
      savePortalSession(data);
      toast.success(`Welcome, ${data.name || data.email}`);
      window.history.replaceState(null, "", window.location.pathname);
      nav(portalType === "student" ? "/student" : "/applicant", { state: { user: data } });
    } catch (e) {
      console.error("Google session exchange failed:", e);
      toast.error(e.response?.data?.detail || "Google sign-in failed");
      nav(portalType === "student" ? "/student/login" : "/applicant/login");
    }
  }, [nav]);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const portalType = localStorage.getItem("ns_portal_type") || "applicant";
    if (!sid) {
      nav(portalType === "student" ? "/student/login" : "/applicant/login");
      return;
    }
    exchange(sid, portalType);
  }, [location.hash, nav, exchange]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#0B1E3F] text-white">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-2 border-[#C9A961]/40 border-t-[#C9A961] rounded-full mx-auto mb-4" />
        <div className="text-sm uppercase tracking-[0.3em] text-[#C9A961]">Signing you in…</div>
      </div>
    </div>
  );
}
